<template>
  <div id="home">
    <div class="container">
      <mt-field label="車牌" placeholder="XXX-XXXX" v-model="license"></mt-field>
      <mt-field label="姓名" placeholder="如何稱呼" v-model="name"></mt-field>
      <mt-field label="手機" placeholder="請輸入聯絡電話" type="tel" v-model="phone"></mt-field>
    </div>
    <div class="container">
      <mt-radio
        title="車輛故障情形"
        v-model="classify"
        align="left"
        :options="['沒電、沒油','破胎（更換備胎）','破胎（拖吊）','拋錨發不動，可以空檔', '車輪卡水溝、車陷沙灘泥地', '車輛故障於地下室', '車禍事故，車輪無法正常轉動']">
      </mt-radio>
    </div>
    <div class="container" v-if="!calc.display">
      <label class="mint-radiolist-title region">故障地點<mt-switch class="right" v-model="gps">GPS定位</mt-switch></label>
      <hr>
      <div class="left-col" v-if="!gps">
        <select class="city-select" v-model="selectCity">
          <option value="">--請選擇--</option>
          <option v-for="city in cityList" :key="city.CityName" :value="city.CityName">{{city.CityName}}</option>
        </select>
      </div>
      <div class="right-col" v-if="!gps">
        <select v-show="showArea" class="city-select" v-model="selectArea">
          <option value="">--請選擇區域--</option>
          <option v-for="area in areaList" :key="area.AreaName" :value="area.AreaName">{{area.AreaName}}</option>
        </select>
      </div>
      <div v-if="!gps" v-show="selectArea.length > 0" class="full-col">
        <select v-show="selectArea.length > 0" class="city-select" v-model="selectRoad">
          <option value="">--請選擇路段--</option>
          <option v-for="road in roadList" :key="road.RoadName" :value="road.RoadName">{{road.RoadName}}</option>
        </select>
      </div>
      <div class="full-col">
        <input class="city-select" type="text" v-model="address" placeholder="地址">
      </div>
    </div>
    <div class="container" v-if="calc.display">
      <label class="mint-radiolist-title region">故障地點</label>
      <hr>
      <div class="full-col">
        <input class="city-select" type="text" v-model="calc.startAddress" placeholder="故障地址">
      </div>
    </div>
    <div class="container" v-if="calc.display">
      <label class="mint-radiolist-title region">目的地點</label>
      <hr>
      <div class="full-col">
        <input class="city-select" type="text" v-model="calc.endAddress" placeholder="目的地址">
      </div>
    </div>
    <div class="container">
      <mt-field label="情況備註" placeholder="備註..." type="textarea" rows="4" v-model="description"></mt-field>
    </div>
    <div class="last-submit">
      <mt-button type="primary" size="large" :disabled="isDisable" @click="create">送出叫車訊息</mt-button>
    </div>
    <div class="last-submit">
      <a href="tel:0225177027"><mt-button type="danger" size="large">直接撥打客服電話</mt-button></a>
    </div>
    <mt-popup
      v-model="popupVisible"
      position="bottom"
      popup-transition="popup-fade">
        <div class="content-wrapper">
          <div id="map-canvas" v-if="popupVisible">
            <gmap-map ref="home" @center_changed="updateCenter" :center="center" :zoom="zoom" :options="mapOptions" disableDefaultUI="false" style="width: 100%; height: 100%; position: absolute; left:0; top:0">
              <gmap-marker
                :position="center"
              ></gmap-marker>
            </gmap-map>
            
            <button class="location" @click="getCurrentGeo"><i class="material-icons">gps_fixed</i></button>
          </div>
          <div class="full-input-wrapper" v-show="startAddress.length > 0">
            <input type="text" v-model="startAddress">
          </div>
          <div class="full-btn-wrapper">
            <mt-button class="close" type="primary" @click="confirmLocation">確認位置</mt-button>
          </div>
        </div>
    </mt-popup>
  </div>
</template>

<script>
import { MessageBox } from 'mint-ui';
export default {
  name: 'home',
  data () {
    return {
      license: '',
      name: '',
      phone: '',
      classify: '拋錨發不動，可以空檔',
      selectCity: '',
      selectArea: '',
      selectRoad: '',
      address: '',
      cityList: [],
      areaList: [],
      roadList: [],
      description: '',
      gps: false,
      loading: false,
      popupVisible: false,
      mapOptions: {
        disableDefaultUI: true,
        zoomControl: false,
        scrollwheel: false,
        gestureHandling: "cooperative",
      },
      center: { lat: 25.047523, lng: 121.539878 },
      zoom: 11,
      centerHandler: null,
      geocoder: null,
      startAddress: ""
    }
  },
  props: ['calc'],
  computed: {
    isDisable() {
      if (this.name.length == 0 || !this.name) {
        return true;
      } else if (this.phone.length == 0 || !this.phone) {
        return true;
      } else if (this.loading) {
        return true;
      } else {
        return false;
      }
    },
    showArea() {
      if (this.areaList.length > 0) {
        return true;
      } else {
        return false;
      }
    }
  },
  watch: {
    selectCity(value) {
      this.fetchArea(value);
      this.address = value;
    },
    selectArea(value) {
      this.fetchRoad(this.selectCity, value);
      this.address = this.selectCity+value;
    },
    selectRoad(value) {
      this.address = this.selectCity+this.selectArea+value;
    },
    gps(value) {
      if (value) {
        this.popupVisible = value;
        navigator.geolocation.getCurrentPosition((position) => {
          this.center = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };
          this.getAddress();
        });
        if (!this.geocoder) {
          this.geocoder = new google.maps.Geocoder();
        }
      }
    }
  },
  methods: {
    confirmLocation() {
      this.popupVisible = false;
      this.address = this.startAddress;
    },
    getAddress() {
      let latlng = new google.maps.LatLng(this.center.lat, this.center.lng);
      this.geocoder.geocode({'latLng': latlng}, (results, status) => {
        if (status == google.maps.GeocoderStatus.OK) {
          if (results[0]) {
            this.startAddress = results[0].formatted_address;
          }
        }
      })
    },
    getCurrentGeo() {
      navigator.geolocation.getCurrentPosition((position) => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
        this.getAddress();
      });
    },
    fetchCity() {
      this.$http.get('https://igcar.center/api/address/city')
      .then((res) => {
        this.cityList = res.body;
      })
      .catch((err) => {
        console.log('err', err);
      })
    },
    fetchArea(CityName) {
      this.$http.get('https://igcar.center/api/address/area?CityName='+CityName)
      .then((res) => {
        this.areaList = res.body;
      })
      .catch((err) => {
        console.log('err', err);
      })
    },
    fetchRoad(CityName, AreaName) {
      this.$http.get('https://igcar.center/api/address/road?CityName='+CityName+'&AreaName='+AreaName)
      .then((res) => {
        this.roadList = res.body;
      })
      .catch((err) => {
        console.log('err', err);
      })
    },
    getMsg() {
      if (this.calc.display) {
        return '案件類別：錄得清行車記錄器\n'+
              '車牌號碼：'+this.license+'\n'+
              '聯絡電話：'+this.name+' '+this.phone+'\n'+
              '車輛情況：'+this.classify+'\n'+
              '所在地址：'+this.calc.startAddress+'\n'+
              '目的地址：'+this.calc.endAddress+'\n'+
              'GPS定位：'+this.getGpsPoint()+'\n'+
              '情況備註：'+this.description+ '\n'+
              '里程價格：'+this.calc.price+ '\n'+
              '額外價格：'+this.calc.other+ '\n'+
              '估計總價：'+this.calc.total+ '\n'
      } else {
        return '案件類別：錄得清行車記錄器\n'+
              '車牌號碼：'+this.license+'\n'+
              '聯絡電話：'+this.name+' '+this.phone+'\n'+
              '車輛情況：'+this.classify+'\n'+
              '所在地址：'+this.address+'\n'+
              'GPS定位：'+this.getGpsPoint()+'\n'+
              '情況備註：'+this.description
      }
    },
    create() {
      this.loading = true;
      let data = {
        name: this.name,
        phone: this.phone,
        classify: this.classify,
        text: this.getMsg(),
      }
      this.$http.post('https://igcar.center/api/igcar/looking', data)
      .then((res) => {
        console.log(res.body);
        this.loading = false;
        MessageBox({
          title: '送出申請',
          message: '已將訊息傳送至客服中心，請注意您的回撥來電',
          showCancelButton: false,
          confirmButtonText: '我知道了'
        });
      })
      .catch((err) => {
        this.loading = false;
        console.log('err', err);
        MessageBox({
          title: '發生錯誤',
          message: '請撥(02)2517-7027聯絡服務人員',
          showCancelButton: false,
          confirmButtonText: '確認'
        });
      })
    },
    getGpsPoint() {
      if (this.gps) {
        return `(${this.center.lat}, ${this.center.lng}`
      } else {
        return '無提供';
      }
    },
    updateCenter(newCenter) {
      if (this.centerHandler) {
        clearTimeout(this.centerHandler);
      }
      this.centerHandler = setTimeout(()=> {
        this.center = {
          lat: newCenter.lat(), lng: newCenter.lng()
        }
        this.getAddress();
      }, 1000);
    }
  },
  created() {
    this.fetchCity();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  #map-canvas {
    width: 100%;
    height: 100%;
    position: relative;
  }
  .location {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    border: 0;
    background: #f1f1f1;
    position: absolute;
    bottom: 80px;
    right: 10px;
    font-size: 1.5em;
    padding: 0;
    box-sizing: border-box;
    -webkit-box-shadow: 0px 0px 5px 2px rgba(0,0,0,0.2);
    -moz-box-shadow: 0px 0px 5px 2px rgba(0,0,0,0.2);
    box-shadow: 0px 0px 5px 2px rgba(0,0,0,0.2);
  }
  .location i {
    line-height: 60px;
  }
  #home {
    padding: 8px;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
  }
  .container {
    background: #fff;
    border-radius: 3px;
    padding: 6px;
    -webkit-box-shadow: 0px 0px 1px 1px rgba(0,0,0,0.3);
    -moz-box-shadow: 0px 0px 1px 1px rgba(0,0,0,0.3);
    box-shadow: 0px 0px 1px 1px rgba(0,0,0,0.3);
    margin-bottom: 8px;
    text-align: left;
    overflow: hidden;
    box-sizing: border-box;
  }
  .city-select {
    width: 100%;
    font-size: 1em;
    padding: 2px;
    height: 40px;
    border: 1px solid rgba(0,0,0,0.3);
    border-radius: 6px;
    box-sizing: border-box;
  }
  input.city-select {
    padding: 2px 6px;
  }
  .region {
    width: 100%;
    box-sizing: border-box;
    line-height: 32px;
  }
  .mint-radiolist-title.region {
    margin: 0 8px;
  }
  .mint-switch.right {
    float: right;
    margin-right: 20px;
  }
  .left-col, .right-col {
    width: 50%;
    float: left;
    box-sizing: border-box; 
  }
  .left-col {
    padding-right: 3px;
  }
  .right-col {
    padding-left: 3px; 
  }
  .full-col {
    float: left;
    margin-top: 5px;
    width: 100%;
  }
  .last-submit {
    padding-bottom: 8px;
    width: 100%;
  }
  .last-submit a {
    text-decoration: none;
  }
  hr {
    border: 0;
    height: 1px;
    background-color: #e4e4e4;
  }
  .pull-right {
    float: right;
  }
  .mint-radiolist-title.region {
    display: inline-block;
  }
  .mint-popup-bottom {
    width: 100%;
    height: 100%;
  }
  .content-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
  }
  .full-btn-wrapper {
    position: absolute;
    bottom: 0;
    left: 0;
    padding: 6px;
    width: 100%;
    box-sizing: border-box;
    opacity: 0.9;
  }
  .full-input-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    padding: 6px;
    width: 100%;
    box-sizing: border-box;
  }
  .full-input-wrapper input {
    border: 1px solid rgba(0,0,0,0.2);
    width: 100%;
    height: 50px;
    padding: 0 10px;
    box-sizing: border-box;
  }
  .close {
    width: 100%;
  }
  iframe {
    width: 100%;
    height: 100%;
  }

</style>


// WEBPACK FOOTER //
// src/components/Home.vue